import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1.04492V11H22.9552C22.4796 5.7229 18.2771 1.52047 13 1.04492Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 1.04492V13H22.9552C22.45 18.6065 17.7381 23.0001 12 23.0001C5.92487 23.0001 1 18.0752 1 12.0001C1 6.26204 5.3935 1.55015 11 1.04492Z"}}]};

const ChartPieFilled = Vue.extend<IconProps>({
  name: 'ChartPieFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-pie-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartPieFilled;
